import { SendTestReminderPayload } from '../core/test-reminders';
import { HttpClient } from './http';

export interface TestRemindersService {
  send: (dto: SendTestReminderPayload) => Promise<void>;
}

export function createTestRemindersService(
  httpClient: HttpClient,
  baseUrl: string,
): TestRemindersService {
  return {
    send: (dto: SendTestReminderPayload) => {
      return httpClient<void>(`${baseUrl}/test-reminders`, 'post', {
        body: dto,
      });
    },
  };
}
